import {
  LoadStatus,
  enumLoadSortOption,
} from '@rematter/frontend-lib-api-client';
import { humanReadableDate } from '@rematter/ui-web';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';
import { getLocale } from '~/shared/utils/locale';

export type SelectableLoad = QueryHookResult<typeof useLoadsQuery>[number];

export const useLoadsQuery = createQueryHook(
  'shared.selectLoad',
  (params: {
    ids?: string[];
    statuses?: LoadStatus[];
    searchTerm?: string;
  }) => ({
    loads: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          status: params.statuses,
        },
        sorting: [enumLoadSortOption.CreatedAtDesc],
        pagination: {
          limit: 20,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        status: true,
        expectedShipDate: true,
        facility: {
          facilityName: true,
        },
      },
    },
  }),
  {
    select: (data) => data.loads.entries ?? [],
  },
);

export const SelectLoad = createEntityComboBox.remotelySearched(
  'SelectLoad',
  useLoadsQuery,
  {
    formatLabel: (load) => `#${load.documentNumber}`,
    formatSubLabel: (load) =>
      [
        load.facility?.facilityName,
        load.expectedShipDate &&
          humanReadableDate(load.expectedShipDate, { locale: getLocale() }),
      ]
        .filter(Boolean)
        .join(' ・ '),
  },
);
